module.exports = __webpack_public_path__ + "static/media/intra_oral_right.8939925b.png";